import React, { Component, useState } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';

import { metadataService } from '../../_services/metadata.service'
import { Button, FormGroup, Label, Input, FormText , Row, Col, CustomInput,Popover, PopoverBody, Modal, ModalBody , ModalHeader, ModalFooter} from 'reactstrap';
import { FaInfoCircle as FaInfo  } from "react-icons/fa";
import { configurationActions } from '../../_actions';

function SlButton({name,size,cssClass,onClick,disabled,isLPXInMaintenanceCheck}){
    const handleOnCLick = (event) => {
        if (!disabled) {
            onClick(event);
            isLPXInMaintenanceCheck();
        }
    }
    return <Button 
              name={name} 
              outline 
              color="secondary" 
              size={size} 
              className={cssClass} 
              style={{'margin':'18px 0px 0px 0px'}} 
              onClick={handleOnCLick} 
              disabled={disabled}>{metadataService.getButton(name)}
            </Button>
};
SlButton.propTypes = {
    name: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    size: PropTypes.string,
    cssClass: PropTypes.string
};
SlButton.defaultProps = {
  disabled:false,
  size:"lg"
}
const mapDispatchToProps = (dispatch) => {
  return {
    isLPXInMaintenanceCheck: () => {
      dispatch(configurationActions.isLPXInMaintenance());
    },
  };
};
const connectedSlButton = connect(
  state => { return { language : state.users.language}},
  mapDispatchToProps
)(SlButton);
export {connectedSlButton as SlButton};

export function SlPageTitle(props){
    return (<h1 className='text-center Page-Title'>{metadataService.getTitle(props.pageName)}</h1>);
}
SlPageTitle.propTypes = {
    pageName: PropTypes.string.isRequired
};

export function SlSectionTitle(props){
  return (<h2 className={'text-center h2-title ' + props.className}>{metadataService.getTitle(props.sectionName)}&nbsp;{props.children}</h2>);
}
SlSectionTitle.propTypes = {
  sectionName: PropTypes.string.isRequired,
  className: PropTypes.string
};
SlSectionTitle.defaultProps = {
  className: "",   
}

export function SlSectionLabel(props) {
    return (<h6 className={"h6-title " + props.className + (props.centered === true ? " text-center" : " h6-title-margin")}>{metadataService.getTitle(props.sectionName)}&nbsp;{props.children}</h6>)
}
SlSectionLabel.proptypes = {
    sectionName: PropTypes.string.isRequired,
    centered: PropTypes.bool,
    className: PropTypes.string
}
SlSectionLabel.defaultProps = {
    centered: false,   
    className: ""
}


export function SlBranchDisplay({sunLoanBranch}){
  if(sunLoanBranch){
  const {branchName,address1,address2,city,state,postalCode,phone} = sunLoanBranch;
  return(
    <div>
      {branchName && <p className="mb-0">{branchName}</p>}
      {address1 && <p className="mb-0">{address1}</p>}
      {address2 && <p className="mb-0">{address2}</p>}
      {city && <p className="mb-0">{`${city}, ${state} ${postalCode}`}</p>}
      {phone && <p className="text-danger mt-3"><u>{phone}</u></p>}
    </div>
  )
  }
  return(
    <div>
      Customer Service Center<br/>
      {metadataService.getLabel("SupportPhone")}
    </div>
  )
}


export function SlBusyIndicator({visible = false,className="d-flex justify-content-center p-3"}){
    if (visible) {
      return (
        <div className={className}>
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      );
    }
    return null;
}

export function SlFormEntryRow({children, className = ""}) {
  return (
    <Row className={`sl-form-entry-row ${className}`}>
      <Col xs={12} md={{ size: 8, offset: 0 }} >{children}</Col>
    </Row>
  );
}

export function SlEditorButton(props){
  return (
  <div className={'pointer'} style={{textAlign:'right'}}><a onClick={props.onClick}><span className='screenReaderHiddenText'>{metadataService.getButton("EditProfile")}</span><i className="fa fa-pencil" aria-hidden="true" ></i></a></div>
  )
}

export function SlYesNo(props){
  const fieldLabel = props.labelName ? metadataService.getLabel(props.labelName) : metadataService.getFieldNameLabel(props.name)
  if(props.visible){
    return(
    <FormGroup  tag='fieldset'>
      {props.labelName && (
      <Row className={"text-center"}>
        <Col sm='12'  className={props.labelCssClass}>
        <Label  for={props.name}>{fieldLabel}</Label>
      </Col> 
      </Row>)}
      <Row className={"yes-no-radio-mobile"}>
        <Col sm={{size: 6}} className="text-center">
        <Label check>
      <Input type="radio" name={props.name} value={props.trueValue}
        checked={props.value === props.trueValue} onChange={props.onChange} disabled={props.disabled}/>{props.trueText}
        </Label>
        </Col>
        <Col sm="6" className="text-center">
        <Label check>
      <Input type="radio" name={props.name} value={props.falseValue}
        checked={props.value === props.falseValue} onChange={props.onChange} disabled={props.disabled}/>{props.falseText}
        </Label>
        </Col>
      </Row>
      { (props.helpText && (<FormText>{props.helpText}</FormText>))}
    </FormGroup>
    )
  }
  return null;
}
SlYesNo.propTypes = {
  name: PropTypes.string.isRequired, 
  onChange: PropTypes.func.isRequired, 
  helpText: PropTypes.func , 
  value: PropTypes.string.isRequired, 
  disabled: PropTypes.bool, 
  labelName: PropTypes.string, 
  visible: PropTypes.bool, 
  trueValue: PropTypes.string, 
  falseValue: PropTypes.string, 
  trueText: PropTypes.string, 
  falseText: PropTypes.string
}
SlYesNo.defaultProps = {
  disabled: false, 
  visible:true,
  labelCssClass: ""
}


export function SlVertYesNo(props) {
    const fieldLabel = props.labelName ? metadataService.getLabel(props.labelName) : metadataService.getFieldNameLabel(props.name)
    if (props.visible) {
        return (
            <FormGroup tag='fieldset'>
                {props.labelName && (
                    <Row className="text-center">
                        <Col sm='12'>
                            <Label for={props.name}>{fieldLabel}</Label>
                        </Col>
                    </Row>)}
                <Row>
                    <Col sm='12'>
                        <Label check>
                            <Input type="radio" name={props.name} value={props.trueValue}
                                checked={props.value === props.trueValue} onChange={props.onChange} disabled={props.disabled} />{props.trueText}
                        </Label>
                    </Col>
                </Row>
                <Row>
                    <Col sm='12'>
                        <Label check>
                            <Input type="radio" name={props.name} value={props.falseValue}
                                checked={props.value === props.falseValue} onChange={props.onChange} disabled={props.disabled} />{props.falseText}
                        </Label>
                    </Col>
                </Row>
                {(props.helpText && (<FormText>{props.helpText}</FormText>))}
            </FormGroup>
        )
    }
    return null;
}
SlVertYesNo.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    helpText: PropTypes.func,
    value: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    labelName: PropTypes.string,
    visible: PropTypes.bool,
    trueValue: PropTypes.string,
    falseValue: PropTypes.string,
    trueText: PropTypes.string,
    falseText: PropTypes.string
}
SlVertYesNo.defaultProps = {
    disabled: false,
    visible: true
}


export function SlImgYesNo(props) {
    const fieldLabel = props.labelName ? metadataService.getLabel(props.labelName) : metadataService.getFieldNameLabel(props.name)
    if (props.visible) {
        return (
            <FormGroup tag='fieldset'>
               {props.labelName && (
                   <Row className="text-center">
                       <Col sm='12'>
                           <Label for={props.name}>{fieldLabel}</Label>
                       </Col>
                   </Row>)}
               <Row>
                   <Col>
                       <Label check>
                           {props.hideNoInput !== true &&  <Input style={{display: "none"}} type="radio" name={props.name} value={props.falseValue}
                                                                  checked={props.value === props.falseValue} onChange={props.onChange} disabled={props.disabled} />}
                           <img className={props.imageClassPickUp} src={props.falseImageSource} />{props.falseText}
                       </Label>
                   </Col>
                   <Col >
                       <Label check>
                           {props.hideYesInput !== true && <Input style={{display: "none"}} type="radio" name={props.name} value={props.trueValue}
                               checked={props.value === props.trueValue} onChange={props.onChange} disabled={props.disabled} />}
                           <img className={props.imageClassEDelivery}  src={props.trueImageSource} /> {props.trueText}
                       </Label>
                   </Col>
               </Row>
               {(props.helpText && (<FormText>{props.helpText}</FormText>))}
            </FormGroup>
            // <FormGroup tag='fieldset'>
            //     {props.labelName && (
            //         <Row className="text-center">
            //             <Col sm='12'>
            //                 <Label for={props.name}>{fieldLabel}</Label>
            //             </Col>
            //         </Row>)}
            //     <Row>
            //         <Col sm='12'>
            //             <Label check>
            //                 <img className={props.imageClassEDelivery}  src={props.trueImageSource} /> {props.trueText}
            //             </Label>
            //         </Col>
            //     </Row>
            //     <Row>
            //         <Col sm='12'>
            //             <Label check>
            //                 <Input type="radio" name={props.name} value={props.falseValue}
            //                     checked={props.value === props.falseValue} onChange={props.onChange} disabled={props.disabled} />
            //                 <img className={props.imageClassPickUp} src={props.falseImageSource} />{props.falseText}
            //             </Label>
            //         </Col>
            //     </Row>
            //     {(props.helpText && (<FormText>{props.helpText}</FormText>))}
            // </FormGroup>
        )
    }
    return null;
}
SlImgYesNo.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    helpText: PropTypes.func,
    value: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    labelName: PropTypes.string,
    visible: PropTypes.bool,
    trueValue: PropTypes.string,
    falseValue: PropTypes.string,
    trueText: PropTypes.string,
    falseText: PropTypes.string,
    trueImageSource: PropTypes.string.isRequired,
    falseImageSource: PropTypes.string.isRequired,
    imageClassEDelivery: PropTypes.string.isRequired,
    imageClassPickUp: PropTypes.string.isRequired,
    hideYesInput: PropTypes.bool,
    hideNoInput: PropTypes.bool,
}
SlImgYesNo.defaultProps = {
    disabled: false,
    visible: true,
    hideYesInput : false,
    hideNoInput : false,
}


export function SlRadioButton(props){
  
  return (
    <FormGroup tag="fieldset" check>
    <Label check>
      <Input type="radio" name={props.fieldName} value={props.value}
        checked={props.isSelected} onChange={props.onChange} disabled={props.disabled}/>
        {props.children}
    </Label>
    { (props.helpText && (<FormText>{props.helpText}</FormText>))}
    
  </FormGroup>
  )
}
SlRadioButton.propTypes = {
  fieldName: PropTypes.string.isRequired, 
  isSelected: PropTypes.bool, 
  onChange: PropTypes.func.isRequired, 
  helpText: PropTypes.string , 
  value: PropTypes.string.isRequired, 
  disabled: PropTypes.bool
}
SlRadioButton.defaultProps = {
  disabled: false
}


export function SlCheckBox(props) {
    return (
        <FormGroup tag="fieldset" check>
            <Label check>
                <Input type="checkbox" name={props.fieldName} value={props.value}
                    checked={props.isSelected} onChange={props.onChange} disabled={props.disabled} />
                {(props.labelText && (<FormText className={"no-vmargin"}>{props.labelText}</FormText>))}
            </Label>
            {(props.helpText && (<FormText>{props.helpText}</FormText>))}

        </FormGroup>
    )
}

SlCheckBox.propTypes = {
    fieldName: PropTypes.string.isRequired,
    isSelected: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    helpText: PropTypes.func,
    labelText: PropTypes.string,
    value: PropTypes.string.isRequired,
    disabled: PropTypes.bool
}
SlCheckBox.defaultProps = {
    disabled: false
}

export function SlInfoIcon({message = "", iconSize = 20, id="SlInfoIcon-",placement="bottom"}){
  const [show,setShow] = useState(false);
 
  return <span>
  <i 
    onMouseEnter={()=> setShow(true)}
    onMouseLeave={()=> setShow(false)}
    id={id}
    >
    <FaInfo size={iconSize} />
  </i>
  <Popover
          placement={placement}
          isOpen={show}
          target={id}
          toggle={() => setShow(false)}
        >
          <PopoverBody>
            <div className="row">
              <div className="col">
                <p>{message}</p>
              </div>
            </div>
          </PopoverBody>
        </Popover>
  </span> 
}

export function SlConfirmationModal({
  text = null,
  onCancel,
  onConfirm,
  visible = false,
}) {
  return (
    <div>
      <Modal isOpen={visible} toggle={onCancel}>
        <ModalHeader toggle={onCancel}>
          {metadataService.getLabel("Confirm")}
        </ModalHeader>
        <ModalBody>
          {text || metadataService.getMessage("AreYouSurePerformAction")}
        </ModalBody>
        <ModalFooter>
          <SlButton name="OK" onClick={onConfirm}></SlButton>
          <SlButton name="Cancel" onClick={onCancel}></SlButton>
        </ModalFooter>
      </Modal>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/editors/widgets.jsx